export const COMPETITION_ID = '-NgI5MktKb9Gv8s0J84B';
